var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import _, { orderBy } from 'lodash';
import { useState } from 'react';
import { format, utcToZonedTime } from 'date-fns-tz';
import pLimit from 'p-limit';
import { ExportToExcel } from '../../../hooks/ExportToExcel';
import useApi from '../../../hooks/useAPI';
import { useUIStore } from '../../../state';
var limit = pLimit(3);
var ConsolidateReport = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b;
    // eslint-disable-next-line react/prop-types
    var _c = __read(useState('Accounting Report'), 2), ReportType = _c[0], setReportType = _c[1];
    var _d = __read(useState(false), 2), isGenerating = _d[0], setIsGenerating = _d[1];
    var get = useApi().get;
    var setNotification = useUIStore(function (_a) {
        var setNotification = _a.setNotification;
        return setNotification;
    });
    var changeReportType = function (event) {
        setReportType(event.target.value);
    };
    var GenerateConsolidateReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                switch (ReportType) {
                    case 'Accounting Report':
                        runAllReports();
                        break;
                    case 'Runlist Report':
                        ConsolidateRunlistReport();
                        break;
                    default:
                        break;
                }
            }
            catch (error) { }
            return [2 /*return*/];
        });
    }); };
    function postalquantityforstoreflyer(psdata) {
        var _a, _b;
        if (((_b = (_a = psdata.deliveryMode) === null || _a === void 0 ? void 0 : _a.DeliveryModeCounts) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            return ((psdata.house == true ? psdata.deliveryMode.DeliveryModeCounts[0].house_cc_count : 0) +
                (psdata.apt == true ? psdata.deliveryMode.DeliveryModeCounts[0].apt_cc_count : 0) +
                (psdata.bus == true ? psdata.deliveryMode.DeliveryModeCounts[0].bus_cc_count : 0) +
                (psdata.farm == true ? psdata.deliveryMode.DeliveryModeCounts[0].farm_cc_count : 0));
        }
        else
            return 0;
    }
    function FieldConsultant(userdata) {
        var element = [];
        var consultant = _.filter(userdata, function (p) {
            var match = _.includes(['AREA_MANAGER_FRANCHISES', 'AREA_MANAGER_CORPORATE'], p.role.toString());
            return match && p.membership.isActive == true;
        });
        if (Object.entries(consultant).length > 0) {
            for (var index = 0; index < Object.entries(consultant).length; index++) {
                element.push(consultant.map(function (x) { return x.userName; })[index]);
            }
            return element.join(',');
        }
        return '';
    }
    var GenerateDataForAcountReport = function (flyerid) { return __awaiter(void 0, void 0, void 0, function () {
        var StoreFlyerById, storeuserinfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, get("/flyers/".concat(flyerid))];
                case 1:
                    StoreFlyerById = _a.sent();
                    try {
                        if (StoreFlyerById.success) {
                            storeuserinfo = orderBy(StoreFlyerById.data.stores.map(function (details) {
                                var nonQuarterfoldQty = details.distributors
                                    .filter(function (d) { return !d.distributor.quarterfold; })
                                    .reduce(function (a, d) { return a + d.quantity; }, 0);
                                var quarterfoldQty = details.distributors
                                    .filter(function (d) { return d.distributor.quarterfold; })
                                    .reduce(function (a, d) { return a + d.quantity; }, 0);
                                var postalQty = details.postalStations.reduce(function (a, p) { return a + postalquantityforstoreflyer(p); }, 0);
                                return {
                                    StoreName: details.store.name,
                                    StoreNumber: details.store.number,
                                    FieldConsultant: FieldConsultant(details.store.users),
                                    TotalStoreCopies: details.storeCopy,
                                    TotalDistributor: nonQuarterfoldQty,
                                    'TotalDistributor1/4': quarterfoldQty,
                                    TotalPostalStation: postalQty,
                                    TotalQTY: details.storeCopy + nonQuarterfoldQty + quarterfoldQty + postalQty,
                                    Zone: details.store.zone.name,
                                    Owner: details.store.storeOwner.name,
                                    FlyerType: StoreFlyerById.data.flyertype.type,
                                    PageCount: StoreFlyerById.data.pageCount,
                                    SaleDate: format(new Date(utcToZonedTime(StoreFlyerById.data.saleDate, 'UTC')), 'yyyy-MM-dd'),
                                };
                            }), ['StoreNumber', 'SaleDate'], ['asc', 'asc']);
                            return [2 /*return*/, storeuserinfo];
                        }
                        else {
                            return [2 /*return*/, []];
                        }
                    }
                    catch (error) {
                        console.error(error);
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var runAllReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        var flyerIds, tasks, allResults, consolidatedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsGenerating(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    flyerIds = data.map(function (flyer) { return flyer.id; });
                    tasks = flyerIds.map(function (id) { return limit(function () { return GenerateDataForAcountReport(id); }); });
                    return [4 /*yield*/, Promise.all(tasks)];
                case 2:
                    allResults = _a.sent();
                    consolidatedData = allResults.flat();
                    if (consolidatedData.length > 0) {
                        ExportToExcel(consolidatedData, 'Consolidate AccountingReport', 'Consolidate AccountingReport');
                    }
                    else {
                        setNotification('Warning', 'No data to export', 'warning');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setIsGenerating(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var GenerateRunSequenceData = function (flyerid) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, get("/sequences/".concat(flyerid))];
                case 1:
                    result = _b.sent();
                    if (result.success && ((_a = result.exceldata) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        return [2 /*return*/, result.exceldata];
                    }
                    return [2 /*return*/, []];
            }
        });
    }); };
    var ConsolidateRunlistReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tasks, allResults, consolidatedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsGenerating(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    tasks = data.map(function (flyer) {
                        return limit(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var rows, saleDate;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, GenerateRunSequenceData(flyer.id)];
                                    case 1:
                                        rows = _a.sent();
                                        saleDate = flyer.saleDate ? format(new Date(utcToZonedTime(flyer.saleDate, 'UTC')), 'yyyy-MM-dd') : '';
                                        return [2 /*return*/, rows.map(function (row) { return (__assign(__assign({}, row), { SaleDate: saleDate })); })];
                                }
                            });
                        }); });
                    });
                    return [4 /*yield*/, Promise.all(tasks)];
                case 2:
                    allResults = _a.sent();
                    consolidatedData = allResults.flat();
                    if (consolidatedData.length > 0) {
                        ExportToExcel(consolidatedData, 'Consolidate RunlistReport', 'Consolidate RunlistReport');
                    }
                    else {
                        setNotification('Warning', 'No data to export', 'warning');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setIsGenerating(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { className: "mt-6 sm:mt-5 mb-10 space-y-6 sm:space-y-5", children: _jsxs("div", { className: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5", children: [_jsx("label", { htmlFor: "province", className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2", children: "Report Type:" }), _jsx("div", { className: "mt-1 sm:mt-0 sm:col-span-2 relative z-50", children: _jsx("div", { className: "max-w-lg flex rounded-md shadow-sm", children: _jsxs("select", { className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md", onChange: changeReportType, value: ReportType, children: [_jsx("option", { value: "Accounting Report", children: "Accounting Report" }), _jsx("option", { value: "Runlist Report", children: "Runlist Report" })] }) }) }), _jsxs("div", { className: "sm:col-span-3 pt-10", children: [' ', _jsx("div", { className: "max-w-lg sm:ml-auto", children: _jsxs("button", { type: "button", disabled: isGenerating, className: "w-72 inline-flex items-center justify-center gap-2 px-2 py-1.5 text-sm font-medium text-blue-900 bg-blue-100 border border-blue-900 border-opacity-20 rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 disabled:opacity-60 disabled:cursor-not-allowed", onClick: function () { return GenerateConsolidateReport(); }, children: [isGenerating && (_jsxs("svg", { className: "animate-spin h-4 w-4 text-blue-900", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" })] })), isGenerating ? 'Generating...' : 'Generate'] }) })] })] }) }));
};
export default ConsolidateReport;
